import { render, staticRenderFns } from "./StocklistDetails.vue?vue&type=template&id=c6f48604&scoped=true&"
import script from "./StocklistDetails.vue?vue&type=script&lang=js&"
export * from "./StocklistDetails.vue?vue&type=script&lang=js&"
import style0 from "./StocklistDetails.vue?vue&type=style&index=0&id=c6f48604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f48604",
  null
  
)

export default component.exports